import type { HeaderProfileData } from '@presentation/components';
import type { FormikConfig } from 'formik';

export interface EducatorWriteReviewFormValues {
  grade: number;
  acceptedTerms: boolean;
  description: string;
}

export interface EducatorWriteReviewPageData {
  header?: HeaderProfileData;
  form: {
    initialValues: EducatorWriteReviewFormValues;
    onSubmit: (values: EducatorWriteReviewFormValues) => void;
    validate: FormikConfig<EducatorWriteReviewFormValues>['validate'];
  };
}

export interface EducatorWriteReviewPageProps extends EducatorWriteReviewPageData {}
